import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { ISummaryDTO, ISummarySearchDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseSetpointWithoutObjectsDataParams = {
    groupID: number,
    searchCriteria: ISummarySearchDTO,
} & BaseUseQueryParameters<ISummaryDTO | undefined>;

export function useSetpointsWithoutObjectData({
    groupID,
    searchCriteria,
    enabled,    
    onSuccess,
    onError
}: UseSetpointWithoutObjectsDataParams) {
    return useQuery<ISummaryDTO, RestError>(
        keys.setpointsWithoutObjects(groupID, searchCriteria),
        ({ signal }) => {
            return SetpointAdministrationDataService.getSetpointsWithoutObjects(
                groupID, 
                searchCriteria,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false
        }
    );
}